import {ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output} from "@angular/core";

@Component({
    selector: "fui-color-pair-toggle",
    templateUrl: "./color-pair-toggle.component.html",
    styleUrls: ["./color-pair-toggle.component.scss"]
})
export class FUIColorPairToggleComponent {
    @Input() foregroundColor: string;
    @Input() backgroundColor: string;
    @Input() locked: boolean = false;
    @Input() backgroundSelected: boolean;
    @Output() backgroundSelectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private changeDetector: ChangeDetectorRef) {
    }

    public toggle(mouseEvent: MouseEvent): void {
        mouseEvent.stopPropagation();
        if (!this.locked) {
            this.backgroundSelected = !this.backgroundSelected;
            this.backgroundSelectedChange.next(this.backgroundSelected);
        }
    }
}
